import React from 'react';
import SchedulerCalendar from '../../../components/calendar/SchedulerCalendar';
const EMERALD_ID = 'c544a6b1-69b3-4a2e-9d51-6dc3fbd7d647';

export default function ViewEmerald() {
  return (
    <div className="operation-view emerald-view">
      <SchedulerCalendar operationId={EMERALD_ID} />
    </div>
  );
}